import {
  Button,
  CloseButton,
  ColorInput,
  Group,
  Paper,
  TextInput,
  Title,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../components/View/BackButton";
import { createTag } from "../../../../api/TagsAPI";
import { getTagsSwatches } from "../../../../functions/utilFunctions";

const CreateTagPage = () => {
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);
    createTag({ name: data.name, color: data.color.substring(1) })
      .then((response) => {
        setTimeout(() => {
          notifications.show({
            message: lang.tags.row_highlight.created,
            color: "tertiary.8",
          });
        }, 300);
        navigate(`../?highlight=${response.data.tag_id}`);
      })
      .finally(() => setLoading(false));
  };
  return (
    <Paper
      p={"lg"}
      w={"40%"}
      mx={"auto"}
      gap={"xs"}
      component={"form"}
      onSubmit={handleSubmit}
    >
      <CloseButton component={Link} to={".."} size={"lg"} mt={-8} mb={8} />
      <Title order={5} mb={16}>
        {lang.tags.create.dialog.title}
      </Title>
      {/* <Title order={5}>{lang.url_shortener.create.dialog.title}</Title> */}
      <TextInput
        name="name"
        label={lang.tags.create.dialog.tag}
        placeholder={lang.tags.create.dialog.tag}
        autoFocus
        required
        size="md"
        mb={16}
      />

      <ColorInput
        name="color"
        swatches={getTagsSwatches()}
        label={lang.prm.status.color}
        placeholder={lang.prm.status.color}
        size="md"
      />

      <Group justify="flex-end" mt={32}>
        <BackButton />
        <Button type="submit" loading={loading} size="md">
          {lang.tags.create.dialog.submit_button}
        </Button>
      </Group>
    </Paper>
  );
};

export default CreateTagPage;
